import { TextField } from "@mui/material";
import type { ChangeEventHandler } from "react";
import { useState } from "react";

interface TextWithEndTagInputProps {
  endText?: string;
  onInputChange?: (...values: unknown[]) => void;
  defaultValue?: string;
  type?: string;
  disabled?: boolean;
}

const TextWithEndTagInput = ({
  endText,
  onInputChange,
  defaultValue,
  type,
  disabled,
}: TextWithEndTagInputProps) => {
  const [value, setValue] = useState(defaultValue ?? "");
  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setValue(event.target.value);
    if (onInputChange) {
      onInputChange(event.target.value);
    }
  };

  return (
    <TextField
      InputProps={{
        endAdornment: endText ? <p className="ml-2 break-keep text-rmh-gray-800">{endText}</p> : null,
        readOnly: disabled
      }}
      className="w-full"
      onChange={onChange}
      size="small"
      type={type}
      value={value}
    />
  );
};

export default TextWithEndTagInput;
